var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 58,
  height: 58,
  viewBox: "0 0 58 58"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 1)",
  stroke: "#FFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 42.601,
  cy: 11.462,
  r: 5,
  fillOpacity: 1,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "1;0;0;0;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 49.063,
  cy: 27.063,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;1;0;0;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 42.601,
  cy: 42.663,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;1;0;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 49.125,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;1;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 11.399,
  cy: 42.663,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;1;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 4.938,
  cy: 27.063,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;0;1;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 11.399,
  cy: 11.462,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;0;0;1;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 5,
  r: 5,
  fillOpacity: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;0;0;0;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}))))));
export default __webpack_public_path__ + "static/media/spinner.90e83534.svg";
export { SvgComponent as ReactComponent };